import { Injectable } from "@angular/core";
import { Http, Headers, Response, RequestOptions } from "@angular/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import "rxjs/add/operator/map";
import { ServiceOffer } from "../_models/serviceoffer";
import { AuthenticationService } from "../_services/authentication.service";
import { EnvironmentService } from "./index";

@Injectable()
export class ServiceOffersService {
  private baseUrl: string = this.environmentService.getBaseURL() + "/api";

  constructor(
    private http: Http,
    private authenticationService: AuthenticationService,
    private environmentService: EnvironmentService
  ) {}

  getAll(): Observable<ServiceOffer[]> {
    let serviceoffers$ = this.http
      .get(`${this.baseUrl}/serviceoffers`, this.makeHeaders())
      .map(mapServiceOffers)
      .catch(handleError);
    return serviceoffers$;
  }

  getByCar(carid: string): Observable<ServiceOffer[]> {
    let serviceoffers$ = this.http
      .get(`${this.baseUrl}/serviceoffers?car=${carid}`, this.makeHeaders())
      .map(mapServiceOffers)
      .catch(handleError);
    return serviceoffers$;
  }

  create(serviceoffer: ServiceOffer): Observable<ServiceOffer> {
    let newserviceoffer = this.http
      .post(
        `${this.baseUrl}/serviceoffers`,
        JSON.stringify(serviceoffer),
        this.makeHeaders()
      )
      .map(mapServiceOffer);
    return newserviceoffer;
  }
  read(id: string): Observable<ServiceOffer> {
    let serviceoffer = this.http
      .get(`${this.baseUrl}/serviceoffers/${id}`, this.makeHeaders())
      .map(mapServiceOffer);
    return serviceoffer;
  }
  update(serviceoffer: ServiceOffer): Observable<Response> {
    return this.http.put(
      `${this.baseUrl}/serviceoffers/${serviceoffer._id}`,
      JSON.stringify(serviceoffer),
      this.makeHeaders()
    );
  }
  delete(id: string): Observable<Response> {
    return this.http
      .delete(`${this.baseUrl}/serviceoffers/${id}`, this.makeHeaders())
      .map((res: Response) => res.json()) // ...and calling .json() on the response to return data
      .catch((error: any) =>
        Observable.throw(error.json().error || "Server error")
      ); //...errors if any
  }

  private makeHeaders(): RequestOptions {
    let headers = new Headers();

    headers.append("Authorization", this.authenticationService.getToken());
    headers.append("Content-Type", "application/json ");
    headers.append("charset", "UTF-8 ");
    headers.append("Accept", "application/json ");

    let options = new RequestOptions({ headers: headers });
    return options;
  }
}
function mapServiceOffers(response: Response): ServiceOffer[] {
  // uncomment to simulate error:
  // throw new Error('ups! Force choke!');
  return response.json().map(toServiceOffer);
}

function toServiceOffer(r: any): ServiceOffer {
  let serviceoffer = <ServiceOffer>{
    _id: r._id,
    dealer: r.dealer,
    car: r.car,
    km: r.km,
    years: r.years,
    price: r.price,
  };
  return serviceoffer;
}

function mapServiceOffer(response: Response): ServiceOffer {
  // toPerson looks just like in the previous example
  return toServiceOffer(response.json());
}

// this could also be a private method of the component class
function handleError(error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg =
    error.message ||
    `Yikes! There was was a problem with our hyperdrive device and we couldn't retrieve your data!`;
  console.error(errorMsg);

  // throw an application level error
  return Observable.throw(errorMsg);
}



// WEBPACK FOOTER //
// ./src/app/_services/serviceoffers.service.ts